<template>
  <!-- 搜尋列(對齊參考設計):縣市/用途/人數/價格 四欄 + 搜尋。
       首頁 desktop 為單列膠囊;mobile(首頁與結果頁共用)四欄同一列。
       首頁 mobile 搜尋鈕落下一列;結果頁 mobile 下一列為「篩選條件 + 搜尋」(見下方 scss)。
       兩種情境都整個隱藏下方既有 ul。 -->
  <div v-if="isIndex || isResult"
       class="index-search-bar flex"
       :class="{ 'is-result': isResult }">
    <div class="field">
      <svg-icon name="city"
                size="22"
                class="field-icon"></svg-icon>
      <div class="field-body">
        <span class="field-label">{{ $t('menu.location') }}</span>
        <el-select v-model="selectedCity"
                   @change="selectCityOption"
                   placement="bottom"
                   class="field-select"
                   clearable
                   placeholder="不限">
          <el-option :label="'不限'"
                     :value="''"/>
          <el-option v-for="item in cityList"
                     :key="item.city_id"
                     :label="`${item.city_name}`"
                     :value="item.city_id"/>
        </el-select>
      </div>
    </div>
    <span class="field-divider"></span>
    <div class="field">
      <svg-icon name="category"
                size="22"
                class="field-icon"></svg-icon>
      <div class="field-body">
        <span class="field-label">{{ $t('menu.usage') }}</span>
        <el-select v-model="selectedSpace.usage"
                   @change="selectUsageOption"
                   placement="bottom"
                   class="field-select"
                   clearable
                   placeholder="不限">
          <el-option :label="'不限'"
                     :value="''"/>
          <el-option v-for="item in spaceUsageList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </div>
    </div>
    <span class="field-divider"></span>
    <div class="field">
      <svg-icon name="people"
                size="22"
                class="field-icon"></svg-icon>
      <div class="field-body">
        <span class="field-label">{{ $t('menu.people') }}</span>
        <el-select v-model="selectedPeople"
                   @change="selectPeopleOption"
                   placement="bottom"
                   class="field-select"
                   clearable
                   placeholder="不限人數">
          <el-option v-for="item in peopleOptions"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </div>
    </div>
    <span class="field-divider"></span>
    <div class="field">
      <span class="field-icon field-dollar">$</span>
      <div class="field-body">
        <span class="field-label">{{ $t('menu.price') }} (每小時)</span>
        <el-select v-model="selectedPrice"
                   @change="selectPriceOption"
                   placement="bottom"
                   class="field-select"
                   clearable
                   placeholder="不限價格">
          <el-option v-for="item in priceOptions"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </div>
    </div>
    <span class="field-divider isb-date-divider"></span>
    <!-- 日期:AV P1 捕捉導向欄位(reuse 既有 picker + popover);寫入 store/URL 供詢問預填,
         不參與搜尋過濾(見 useSearchWithStore)。以觸發式欄位呈現,非等寬第 5 欄。 -->
    <button type="button"
            class="isb-date"
            ref="datePickerRef"
            @click="showDatePickerPopover">
      <svg-icon name="calendar"
                size="20"
                class="isb-date-icon"></svg-icon>
      <span class="isb-date-text"
            :class="{ 'is-placeholder': !hasSelectedDate }">{{ hasSelectedDate ? formattedPickerDateTime : $t('menu.date') }}</span>
    </button>
    <!-- 結果頁 mobile:篩選條件鈕放在搜尋鈕左側,共處下一列 -->
    <SearchFilter v-if="isResult"
                  class="isb-filter"></SearchFilter>
    <button type="button"
            class="index-search-btn"
            @click="onSearch">
      <svg-icon name="magnifier"
                size="20"
                class="mr-[6px]"></svg-icon>{{ $t('menu.search') }}
    </button>
  </div>

  <ul class="search-bar-wrap"
      :class="[(isIndex || isResult) ? ['index-hide'] : ['pc:border'],{'border-osn-grey-03':isResult }].flat()">
    <li :class="isIndex&&isMobile?'':''">
      <svg-icon name="city"
                size="20"></svg-icon>
      <el-select
          v-model="selectedCity"
          @change="selectCityOption"
          placement="bottom"
          class="type-dropdown"
          clearable
          :placeholder="$t('menu.location')"
      >
        <el-option
            v-for="item in cityList"
            :key="item.city_id"
            :label="`${item.city_name}`"
            :value="item.city_id"
        />
      </el-select>
    </li>
    <li :class="isIndex&&isMobile?'':''">
      <svg-icon name="category"
                size="20"></svg-icon>
<!--      <el-select
          v-model="selectedSpace.type"
          @change="selectTypeOption"
          class="type-dropdown"
          placement="bottom"
          clearable
          :placeholder="$t('menu.type')"
      >
        <el-option
            v-for="item in spaceTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
        />
      </el-select>-->
      <el-select
          v-model="selectedSpace.usage"
          @change="selectUsageOption"
          class="type-dropdown"
          placement="bottom"
          clearable
          :placeholder="$t('menu.usage')"
      >
        <el-option
            v-for="item in spaceUsageList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
        />
      </el-select>
    </li>
    <li @click="onSearch"
        class="text-center bg-osn-yellow-00 text-[15px] font-semibold leading-[40px] pc:rounded-r-full mobile:rounded-full"
        :class="isIndex?['mobile:w-full','pc:min-w-[100px]']:['mobile:min-w-[100%]','pc:min-w-[70px]']">
      {{ $t('menu.search') }}
    </li>
  </ul>


  <el-popover
      ref="datePickerPopoverRef"
      :virtual-ref="datePickerRef"
      :visible="isShowPopover"
      trigger="click"
      virtual-triggering
      width="310px"
      :show-arrow="false"
      placement="bottom-start"
  >
    <div class="date-picker-popover">
      <div class="mb-2 flex justify-between">
        <div class="title">{{ $t('menu.use_time') }}</div>
        <el-icon :size="20" class="cursor-pointer" @click="hideDatePickerPopover"><Close /></el-icon>
      </div>
      <el-date-picker
          v-model="searchDate"
          @change="setRentTime"
          class="date-picker"
          type="date"
          value-format="YYYY/MM/DD"
          :disabled-date="disabledDate"
          :placeholder="$t('menu.choose_date')"
          :editable="false">
      </el-date-picker>
      <div class="day-select"
           @click="isAllDay=!isAllDay,setRentTime()">
        <svg-icon v-if="isAllDay"
                  class="mr-[6px] bg-osn-yellow-00 cursor-pointer"
                  name="check_box"
                  size="18"></svg-icon>
        <div v-else
             class="check-box"></div>
        <span>{{ $t('menu.all_day') }}</span>
      </div>
      <div class="flex items-end time-select">
        <div>
          <div>{{ $t('menu.start_time') }}</div>
          <el-time-select
              v-model="searchStartTime"
              @change="setRentTime"
              :max-time="searchEndTime"
              class="rounded-full"
              :placeholder="$t('menu.time')"
              start="09:00"
              step="00:30"
              end="21:00"
              :editable="false"
              :disabled="isAllDay||!searchDate"/>
        </div>

        <div class="mb-[10px] mx-[6px]">
          <el-icon>
            <Right/>
          </el-icon>
        </div>
        <div>
          <div>{{ $t('menu.end_time') }}</div>
          <el-time-select
              v-model="searchEndTime"
              @change="handleSetRentTime"
              :min-time="searchStartTime"
              :placeholder="$t('menu.time')"
              start="09:00"
              step="00:30"
              end="21:00"
              :editable="false"
              :disabled="isAllDay||!searchDate"
          />
        </div>

      </div>
      <div class="mt-10 flex justify-between">
        <div></div>
        <div class="w-[90px] leading-[40px] text-center bg-osn-yellow-00 text-[15px] font-semibold rounded-full cursor-pointer"
             @click="onSearch">搜尋</div>
      </div>



    </div>
  </el-popover>

  <!--  日期 el-popover 的背景-->
  <div class="absolute top-0 bottom-0 right-0 left-0"
       v-if="isShowPopover"
       @click="hideDatePickerPopover"></div>
</template>
<script setup>
import {computed, defineProps, onMounted, ref, watch, watchEffect} from "vue";
import {useCityStore} from "@/stores/city.js";
import {useCategoryStore} from "@/stores/category.js";
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {Right,Close} from "@element-plus/icons-vue";
import {useI18n} from '#imports';

import {useGoTo} from "@/composables/useGoTo";
import {useSearchWithStore} from "@/composables/useSearchWithStore";
import {useSettingStore} from "@/stores/setting.js";
import SearchFilter from "@/components/SearchResult/SearchFilter.vue";
import {useFilterStore} from "@/stores/filter.js";

import {canRentMaxDay,citySlug,peopleList,peopleCapRange,priceList,priceRange} from "@/config/common.js";



const props = defineProps({
  isIndex: {
    type: Boolean,
    default: false
  },
  isResult: {
    type: Boolean,
    default: false
  }
})
const {$fbq} = useNuxtApp()

const categoryIds = {
  // 類型 VITE_APP_BASE_TYPE_CATEGORY_ID="2"
  // 用途 VITE_APP_BASE_USAGE_CATEGORY_ID="3"
  type: import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID.toString(),
  usage: import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID.toString(),
};

const selectedSpace = reactive({
  type:-1,
  usage:-1
})

const settingStore = useSettingStore()
const cityStore = useCityStore();
const categoryStore = useCategoryStore()
const searchQueryStore = useSearchQueryStore()
const filterStore = useFilterStore();
const {handleSearchWithStore} = useSearchWithStore()
const {goWithQuery} = useGoTo();
const {t} = useI18n();

const selectedCity = ref('');
// 人數/價格欄。id 0「不限」放在選項第一個(取代不夠明顯的清除鈕);選 id 0 → range 落 {}(清空)。
const selectedPeople = ref('');
const selectedPrice = ref('');
const peopleOptions = peopleList;
const priceOptions = priceList;
const searchDate = ref('')
const isAllDay = ref(false)
const searchStartTime = ref('')
const searchEndTime = ref('')
const disabledDate = (time) => {
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const thirtyDaysLater = todayStart + canRentMaxDay * 24 * 60 * 60 * 1000; // 配合預訂的限制
  return time.getTime() < todayStart || time.getTime() > thirtyDaysLater;
}

const datePickerRef = ref()
const datePickerPopoverRef = ref()
const isShowPopover = ref(false)

const isMobile = computed(() => settingStore.isMobile);
const cityList = computed(() => cityStore.getCityList)
const spaceTypeList = computed(() => categoryStore.getSpaceTypeCategories)
const spaceUsageList = computed(() => categoryStore.getUsageCategories)

const hasSelectedDate = computed(() => !!searchDate.value);

const formattedPickerDateTime = computed(() => {
  const date = searchDate.value;
  let dateTimeDisplay = t('menu.time');

  if (date) {
    dateTimeDisplay = date;
  }

  if (searchStartTime.value && searchEndTime.value) {
    const timeRange = `${searchStartTime.value}~${searchEndTime.value}`;
    dateTimeDisplay = `${dateTimeDisplay.slice(-5)} ${timeRange}`;
  }

  return dateTimeDisplay
});

watchEffect(() => {
  const cityId = searchQueryStore.getSearchCityId;
  if (cityId && cityId[0]) {
    selectedCity.value = cityId[0];
  } else {
    selectedCity.value = null;
  }
});

// 結果頁:人數/價格從篩選條件移到搜尋列後,需從 store 反向同步顯示(進站帶 query 或清除時)。
// 空 range → '' 顯示 placeholder;命中某區間 → 對應 id(排除 id 0「不限」)。
function findSelectedRangeId(range, config) {
  if (!range || Object.keys(range).length === 0) return '';
  const matched = Object.keys(config).find(
      (key) => config[Number(key)]?.min === range?.min && config[Number(key)]?.max === range?.max,
  );
  return matched === undefined || Number(matched) === 0 ? '' : Number(matched);
}

watchEffect(() => {
  selectedPeople.value = findSelectedRangeId(searchQueryStore.getPeopleCapRange, peopleCapRange);
});

watchEffect(() => {
  selectedPrice.value = findSelectedRangeId(searchQueryStore.getPriceRange, priceRange);
});

/*watch(() => searchQueryStore.getSearchCategoryIds, (newCategoryObject) => {
  // 類型
  if (newCategoryObject && newCategoryObject[typeCategoryId]) {
    selectedSpaceType.value = newCategoryObject[typeCategoryId][0];
  } else {
    selectedSpaceType.value = '';
  }

  // 用途
  if (newCategoryObject && newCategoryObject[usageCategoryId]) {
    selectedSpaceUsage.value = newCategoryObject[usageCategoryId][0];
  } else {
    selectedSpaceUsage.value = '';
  }
}, {
  deep: true,
  immediate: true
});*/
// 通用監聽函式
function watchSelectedSpace(categoryKey) {
  const categoryId = categoryIds[categoryKey];
  watch(
      () => searchQueryStore.getSearchCategoryIds,
      (newCategoryObject) => {
        if (newCategoryObject && newCategoryObject[categoryId]) {
          selectedSpace[categoryKey] = newCategoryObject[categoryId][0];
        } else {
          selectedSpace[categoryKey] = '';
        }
      },
      {
        deep: true,
        immediate: true,
      }
  );
}

// 初始化監聽
watchSelectedSpace('type');
watchSelectedSpace('usage');


watch(() => searchQueryStore.getRentTimeSelected, (newRentTime) => {

  if (newRentTime) {
    const {rent_type, begin_time, end_time} = newRentTime;
    searchDate.value = begin_time ? begin_time.split(' ')[0] : '';
    isAllDay.value = rent_type === 1;
    searchStartTime.value = begin_time ? begin_time.split(' ')[1].slice(0, 5) : '';
    searchEndTime.value = end_time ? end_time.split(' ')[1].slice(0, 5) : '';
  }
}, {
  deep: true,
  immediate: true
});

onMounted(() => {

  if (props.isIndex) {
    searchQueryStore.initQueryDate()
    applyIndexDefaults()
  }
})

// 首頁預設:縣市=台北市、用途=教室｜會議(人數/價格維持不限=空,placeholder 已顯示)。
// 寫入 store 後,selectedCity 的 watchEffect 與 usage 的 watchSelectedSpace 會同步到下拉顯示。
function applyIndexDefaults() {
  const taipei = cityStore.getCityList.find((c) => c.city_name === '台北市')
  if (taipei) {
    searchQueryStore.setSelectedCityID([taipei.city_id])
  }
  const meetingUsage = categoryStore.getUsageCategories.find(
      (u) => u.name?.includes('教室') && u.name?.includes('會議'),
  )
  if (meetingUsage) {
    searchQueryStore.setSelectedCategoryObject({ [categoryIds.usage]: [meetingUsage.id] })
  }
}


function selectCityOption() {
  if (!selectedCity.value) {
    searchQueryStore.clearCitySelected()
    return
  }
  searchQueryStore.setSelectedCityID([selectedCity.value])

  // GTM 通知事件
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_city',
    selected_city: citySlug[selectedCity.value]
  });

}

/*function selectedSpaceTypeOption() {
  if (!selectedSpaceType.value) {
    searchQueryStore.clearCategoryObjectByKey(typeCategoryId)
    return
  }
  searchQueryStore.setSelectedCategoryObject({
    [typeCategoryId]: [selectedSpaceType.value]
  });
}

function selectedSpaceUsageOption() {
  if (!selectedSpaceUsage.value) {
    searchQueryStore.clearCategoryObjectByKey(usageCategoryId)
    return
  }
  searchQueryStore.setSelectedCategoryObject({
    [usageCategoryId]: [selectedSpaceUsage.value]
  });
}*/

// 通用選擇 category
function selectSpaceOption(categoryKey) {
  const categoryId = categoryIds[categoryKey];

  if (!selectedSpace[categoryKey]) {
    searchQueryStore.clearCategoryObjectByKey(categoryId);
    return;
  }


  searchQueryStore.setSelectedCategoryObject({
    [categoryId]: [selectedSpace[categoryKey]]
  });

  // 取得名稱
  const optionListMap = {
    usage: spaceUsageList.value,
    type: spaceTypeList.value,
  };
  const optionList = optionListMap[categoryKey] || [];

  const selectedName = optionList.find(item => item.id === selectedSpace[categoryKey])?.name || 'not_found';


  // 推送 GA4 事件
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: `select_${categoryKey}`,               // ex: select_usage 或 select_type
    [`selected_${categoryKey}`]: selectedSpace[categoryKey],   // ex: selected_usage = 2
    [`selected_${categoryKey}_name`]: selectedName // ex: selected_usage_name = 拍攝
  });

}


function selectTypeOption() {
  selectSpaceOption('type');
}

function selectUsageOption() {
  selectSpaceOption('usage');
}

function selectPeopleOption() {
  const id = selectedPeople.value;
  searchQueryStore.setSelectedPeopleCapRange(id ? peopleCapRange[id] : {});

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_people',
    selected_people: peopleList.find(item => item.id === id)?.name || ''
  });
}

function selectPriceOption() {
  const id = selectedPrice.value;
  searchQueryStore.setSelectedPriceRange(id ? priceRange[id] : {});

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_price',
    selected_price: priceList.find(item => item.id === id)?.name || ''
  });
}


function setRentTime() {
  const date = searchDate.value;
  const beginTime = isAllDay.value || !searchStartTime.value ? '00:00:00' : searchStartTime.value + ':00'
  const endTime = isAllDay.value || !searchEndTime.value ? '23:59:59' : searchEndTime.value + ':00'
  searchQueryStore.setRentTimeSelected({
    rent_type: isAllDay.value ? 1 : 0,
    begin_time: date ? `${date} ${beginTime}` : '',
    end_time: date ? `${date} ${endTime}` : ''
  })


}

function showDatePickerPopover() {
  isShowPopover.value = true
}

function hideDatePickerPopover() {
  isShowPopover.value = false
}

function handleSetRentTime() {
  setRentTime()
  hideDatePickerPopover()
}

function onSearch() {
  hideDatePickerPopover()
  const tagCategoryId = import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID
  searchQueryStore.initGeoSearch()
  searchQueryStore.clearKeyword()
  // filter 塞到 searchQueryStore
  const categoryTagIDList = filterStore.getSelectedCategoryTag
  const selectedEquipmentList = filterStore.getSelectedEquipment
  const selectedServiceList = filterStore.getSelectedService

  searchQueryStore.setEquipmentIds(selectedEquipmentList)
  searchQueryStore.setServiceIds(selectedServiceList)

  searchQueryStore.setSelectedCategoryObject({
    [tagCategoryId]: categoryTagIDList
  });
  searchQueryStore.setPagination({page: 1})
  $fbq('trackCustom', 'OSSearch')
  handleSearchWithStore()
  goWithQuery('/search-result', {})

}

</script>
<style scoped
       lang="scss">

/* desktop 首頁四欄膠囊搜尋列 */
.index-search-bar {
  @apply mx-auto items-stretch w-[92%] h-[64px] max-w-[786px] bg-osn-white-00 rounded-full shadow-md pl-[8px] pr-[8px];

  .field {
    @apply flex items-center flex-1 min-w-0 px-[16px];
  }

  .field-icon {
    @apply mr-[10px] flex-shrink-0 text-osn-grey-01;
  }

  .field-dollar {
    @apply w-[22px] text-center text-[20px] font-semibold;
  }

  .field-body {
    @apply flex flex-col justify-center w-full min-w-0 text-left;
  }

  .field-label {
    @apply mb-[2px] text-[12px] leading-none text-osn-grey-01;
  }

  .field-divider {
    @apply self-center flex-shrink-0 w-px h-[28px] bg-osn-grey-03;
  }

  .field-select {
    @apply w-full cursor-pointer;
    --el-select-input-focus-border-color: transparent;

    :deep(.el-select__wrapper) {
      @apply p-0 min-h-0 bg-transparent;
      box-shadow: none;
    }

    :deep(.el-select__placeholder) {
      @apply text-[15px] text-osn-grey-02;
    }

    :deep(.el-select__placeholder:not(.is-transparent)) {
      @apply text-osn-dark-grey-00 font-semibold;
    }
  }

  .isb-date {
    @apply flex items-center flex-shrink-0 px-[16px] cursor-pointer;

    .isb-date-icon {
      @apply mr-[8px] flex-shrink-0 text-osn-grey-01;
    }

    .isb-date-text {
      @apply text-[15px] font-semibold text-osn-dark-grey-00 whitespace-nowrap;
    }

    .isb-date-text.is-placeholder {
      @apply font-normal text-osn-grey-02;
    }
  }

  .index-search-btn {
    @apply my-[8px] flex items-center justify-center flex-shrink-0 px-[28px]
    bg-osn-yellow-00 rounded-full text-[15px] font-semibold text-osn-black-00 cursor-pointer;
  }
}

/* mobile 首頁:四欄(地區/用途/人數/價格)同一列,搜尋鈕落下一列 */
@media (max-width: 767px) {
  .index-search-bar {
    @apply flex-wrap h-auto rounded-[16px] py-[8px] gap-y-[4px];

    .field {
      @apply basis-[23%] px-[6px];
    }

    /* 同列塞 4 欄,圖示留給 desktop;分隔線保留 */
    .field-icon,
    .field-dollar {
      @apply hidden;
    }

    .field-label {
      @apply truncate;
    }

    /* 日期觸發欄:自成一列(不擠進 4 欄),分隔線在此情境隱藏 */
    .isb-date-divider {
      @apply hidden;
    }

    .isb-date {
      @apply basis-full justify-center py-[8px] px-0;
    }

    .index-search-btn {
      @apply w-full px-0 py-[10px] my-[4px];
    }
  }

  /* 結果頁:四欄同一列,下一列為「篩選條件(左) + 搜尋」 */
  .index-search-bar.is-result {
    @apply gap-y-[8px];

    /* 篩選條件鈕(SearchFilter 根)推到下一列,靠左 */
    .isb-filter {
      @apply mr-[8px] flex items-center;
    }

    /* 搜尋鈕不再佔滿整列,與篩選鈕並排撐滿剩餘寬度 */
    .index-search-btn {
      @apply w-auto flex-1 my-0;
    }
  }
}

/* 首頁改用上方四欄 .index-search-bar(mobile+desktop),整個隱藏舊 ul。
   tag+class 特異度需高於 ul.search-bar-wrap 才壓得過 flex/inline-flex。 */
ul.search-bar-wrap.index-hide {
  display: none;
}

/*pc版本*/
@media (min-width: 768px) {
  ul.search-bar-wrap {
    @apply h-[40px] leading-[calc(54px-(9px*2))] inline-flex text-[14px] bg-osn-white-00 rounded-full;

    li:not(:first-child) {
      @apply border-l;
    }

    li:not(:first-child,:nth-child(2)) {
      @apply cursor-pointer w-[30%];
    }

    li:not(:last-child) {
      @apply my-[9px] text-osn-grey-02 font-normal inline-flex items-center;

      svg {
        @apply min-w-[20px] mx-[5px];
      }

      select {
        @apply w-full h-full outline-none cursor-pointer;
      }

      .type-dropdown {
        @apply cursor-pointer;
        --el-select-input-focus-border-color: '#FFFFFF';

        :deep(.el-select__wrapper) {
          @apply w-[130px] h-[38px];
          background-color: transparent;
          border-radius: 0;
          box-shadow: 0 0 0 0;
        }
      }
    }

  }
}

/*mobile*/
@media (max-width: 767px) {
  ul.search-bar-wrap {
    @apply px-4 flex flex-wrap justify-between text-[14px];

    li:not(:nth-child(4),:nth-child(5),:nth-child(6),:last-child) {
      @apply mx-[4px] mb-[16px] min-w-[31%] max-w-[32%] flex-1 text-osn-grey-02 font-normal
      inline-flex items-center bg-osn-white-00 rounded-full border border-osn-grey-03;

      svg {
        @apply min-w-[20px] ml-[12px] mr-[6px];
      }

      select {
        @apply outline-none cursor-pointer;
      }

      .type-dropdown {
        @apply mr-2;
        --el-select-input-focus-border-color: '#FFFFFF';

        :deep(.el-select__selection ) {
          @apply w-fit;
        }

        :deep(.el-select__wrapper) {
          @apply justify-normal p-0 w-full h-[38px];
          background-color: transparent;
          border-radius: 0;
          box-shadow: 0 0 0 0;

          .el-select__selected-item {
            @apply max-w-fit truncate;
          }
        }
      }

      span {
        @apply leading-none;
      }
    }
  }
}

.date-picker-popover {
  @apply text-[15px] text-osn-black-00;

  :deep(.date-picker) {
    width: 282px !important;
    height: 44px !important;
  }

  :deep(.el-input__wrapper) {
    @apply rounded-full;
  }

  .day-select {
    @apply mt-[12px] mb-[37px] min-w-[110px] cursor-pointer flex items-center;
    .check-box, img {
      @apply mr-[6px] w-[18px] h-[18px] cursor-pointer;
    }

    .check-box {
      @apply border-2 border-osn-dark-grey-00;
    }
  }
}

.time-select {
  :deep(.el-select) {
    /*開始時間 結束時間*/
    .el-select__wrapper {
      @apply w-[130px] h-[38px] rounded-full;
    }
  }
}

</style>

